module.exports = __webpack_public_path__ + "static/media/refresh.fc4fb614.svg";